module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-2.8d553a99.svg";